<template>
  <div class="showcase">
    <div class="goods-list">
      <div class="goods-item del_tips--cont" v-for="(item, index) in list" :key="index">
        <div class="del_tips" @click.stop="cancelCollect(item)">
          <i class="el-icon-delete"></i>
        </div>
        <div class="goods-item-img">
          <template>
            <div class="goods-img" @click="toDetail(item)">
              <el-image class="image" :src="item.cover" @error="handleError" />
            </div>
            <!-- <div class="default-img" @click="todetail(item)" v-else>
              <el-image class="image" :src="goodsimage" />
            </div>-->
          </template>
        </div>
        <div class="goods-item-info">
          <div class="title multiple">{{ item.title }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { setCollect } from "@/api/common"
export default {
  name: "CoreSkills",
  components: {},
  props: {
    list: {
      type: Array,
      default: () => new Array(),
    },
  },
  data() {
    return {
      moreicon: require("@/assets/home/open.png"),
      goodsimage: require("@/assets/default/image02.jpg"),
    }
  },
  computed: {},
  mounted() { },
  methods: {
    handleError(e) {
      // 当图片加载失败时，将图片地址设置为默认图片
      e.target.src = this.goodsimage
      // 可以添加额外的处理，比如提示用户或者进行日志记录
    },
    toDetail(item) {
      window.localStorage.setItem("menuId", 3)
      this.$store.dispatch("setmenuid", 3)
      this.$router.push({
        path: "/home/album/detail",
        query: {
          id: item.id || "",
        },
      })
    },
    // 取消收藏
    cancelCollect(data) {
      let params = {
        id: data.id,
        type: 2
      }
      setCollect(params).then((res) => {
        if (res.code === 0) {
          this.$message({
            type: 'success',
            message: '取消采集成功!'
          })
          this.$emit('updateComponent')
        }
      }).catch(() => { })
    },
  },
};
</script>
<style scoped lang="scss">
.showcase {
  .goods-list {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;

    .goods-item {
      width: calc((100% - 60px) / 3);
      height: 200px;
      background-color: #fff;
      border-radius: 5px;
      overflow: hidden;
      position: relative;
      margin: 30px 0px 0px 30px;
      flex-shrink: 1;
      cursor: pointer;

      // &:hover {
      //   border: 1px solid rgb(9, 235, 178);
      // }
      .goods-item-img {
        width: 100%;
        height: 100%;
        position: relative;

        .goods-img {
          width: 100%;
          height: 100%;
          background: aliceblue;

          .image {
            display: inline-block;
            -webkit-transition-duration: 0.3s;
            transition-duration: 0.3s;
            -webkit-transition-property: transform;
            transition-property: transform;
            -webkit-transform: translateZ(0);
            transform: translateZ(0);
            box-shadow: 0 0 1px rgba(0, 0, 0, 0);
          }

          .image:hover,
          .image:focus,
          .image:active {
            -webkit-transform: scale(1.1);
            transform: scale(1.1);
          }

          .image {
            width: 100%;
            height: 100%;
          }
        }

        .default-img {
          width: 100%;
          height: 100%;
          // background: #daebfc;
          text-align: center;
          background: aliceblue;

          .image {
            display: inline-block;
            -webkit-transition-duration: 0.3s;
            transition-duration: 0.3s;
            -webkit-transition-property: transform;
            transition-property: transform;
            -webkit-transform: translateZ(0);
            transform: translateZ(0);
            box-shadow: 0 0 1px rgba(0, 0, 0, 0);
          }

          .image:hover,
          .image:focus,
          .image:active {
            -webkit-transform: scale(1.1);
            transform: scale(1.1);
          }

          .image {
            width: 100%;
            height: 100%;
          }
        }
      }

      .goods-item-info {
        width: 100%;
        height: 45px;
        line-height: 45px;
        padding: 0 15px;
        background: rgba(0, 0, 0, 0.5);
        position: absolute;
        left: 0;
        bottom: 0;

        .title {
          color: #fff;
          font-size: 16px;
          font-weight: 400;
        }
      }
    }

    .goods-item:nth-child(3n + 1) {
      margin-left: 0px;
    }
  }
}

@media screen and (max-width: 640px) {
  .showcase {
    .goods-list {
      .goods-item {
        width: calc((100% - 10px) / 2);
        margin: 10px 0 0 10px;
        height: auto;

        .goods-item-img {
          height: 120px;
        }
      }

      .goods-item:nth-child(2n + 1) {
        margin-left: 0 !important;
      }

      .goods-item:nth-child(3n + 1) {
        margin-left: 10px;
      }
    }
  }
}

@media screen and (min-width: 640px) and (max-width: 1200px) {
  .showcase {
    .goods-list {
      .goods-item {
        width: calc((100% - 40px) / 3);
        margin: 20px 0 0 20px;
      }
    }
  }
}
</style>